module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/SS-loading-vector-dd8f1f5c8c765b6146277153dac0fb3f.png";